import React from 'react';
import { styled as styled2 } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { StateText, GrowingScrollableSection } from '../styled.tsx';
import Error from './assets/error.svg';
import messages from './messages.tsx';

export const ErrorState = () => {
	const { formatMessage } = useIntl();

	return (
		<GrowingScrollableSection>
			<Container>
				<ErrorStateIcon src={Error} alt="" />
				<StateText>
					{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
					<strong>{formatMessage(messages.title)}</strong>
					<br />
					{formatMessage(messages.message)}
				</StateText>
			</Container>
		</GrowingScrollableSection>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Container = styled2.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'flexStart',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > p': {
		textAlign: 'center',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const ErrorStateIcon = styled2.img({
	height: '110px',
	marginTop: token('space.500'),
});
